import { AnchorHTMLAttributes, ButtonHTMLAttributes, FC, MouseEventHandler, Ref } from 'react';

import { Link } from '@purpur/library';

import { DivStyledAsLink, StyledButton } from './PlainLink.styles';

type AnchorProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
    href: string;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
};

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    href?: never;
    onClick?: MouseEventHandler<HTMLButtonElement>;
};

type Props = {
    ref?: Ref<HTMLButtonElement | HTMLAnchorElement>;
    styledAsLink?: boolean;
    withPadding?: boolean;
    size?: 'xs' | 'sm' | 'md' | 'lg';
    negative?: boolean;
} & (AnchorProps | ButtonProps);

export const PlainLink: FC<Props> = ({
    onClick,
    children,
    href,
    ref,
    styledAsLink,
    size,
    withPadding,
    negative,
    ...rest
}) => {
    if (href) {
        return (
            <Link
                href={href}
                variant="text"
                negative={negative}
                onClick={onClick as MouseEventHandler<HTMLAnchorElement>}
                {...(rest as AnchorHTMLAttributes<HTMLAnchorElement>)}
            >
                {children}
            </Link>
        );
    }

    if (onClick) {
        return (
            <StyledButton
                variant="text"
                size={size || 'xs'}
                negative={negative}
                $styledAsLink={!!styledAsLink}
                $withPadding={!!withPadding}
                onClick={onClick as MouseEventHandler<HTMLButtonElement>}
                ref={ref as Ref<HTMLButtonElement>}
                {...(rest as ButtonHTMLAttributes<HTMLButtonElement>)}
            >
                {children}
            </StyledButton>
        );
    }

    return <DivStyledAsLink>{children}</DivStyledAsLink>;
};
